import { PageBlock } from '@/types/directus-schema';
import BaseBlock from '@/components/blocks/BaseBlock';

interface PageBuilderProps {
	sections: PageBlock[];
}

const PageBuilder = ({ sections }: PageBuilderProps) => {
	const validBlocks = sections.filter((block): block is PageBlock & { collection: string } => {
		if (typeof block.collection !== 'string') return false;
		// Forms don't need an item, they render themselves
		if (block.collection === 'block_quote_form' || block.collection === 'block_business_quote_form') return true;

		return !!block.item && typeof block.item === 'object';
	});

	return (
		<div>
			{validBlocks.map((block) => {
				// We read anchor_id if it exists, stripping out any user-entered hashtag for the HTML ID.
				const anchorId = block.item?.anchor_id ? block.item.anchor_id.replace(/^#/, '') : undefined;

				return (
					<div key={block.id} id={anchorId} data-background={block.background}>
						<BaseBlock
							block={{
								collection: block.collection,
								item: block.item,
								id: block.id,
							}}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default PageBuilder;
